var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-robot3 {\r\n        fill: #ffcf04;\r\n      }\r\n\r\n      .cls-robot4 {\r\n        fill: #003893;\r\n      }\r\n\r\n      .cls-robot5 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 110.55,
    height: 110.55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1226",
    "data-name": "Grupo 1226"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1225",
    "data-name": "Grupo 1225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_941",
    "data-name": "Trazado 941",
    className: "cls-robot5",
    d: "M55.23-.13C24.68-.13-.09,24.64-.09,55.19c0,30.55,24.77,55.32,55.32,55.32,30.55,0,55.32-24.77,55.32-55.32S85.78-.13,55.23-.13c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_942",
    "data-name": "Trazado 942",
    className: "cls-robot3",
    d: "M79.75,20.58h0s-14.42,0-14.42,0c-5.57,0-10.09,4.52-10.1,10.1v20.76c0,2.08,1.69,3.77,3.77,3.77.75,0,1.48-.22,2.1-.64l7.55-5.13h11.1c5.57,0,10.09-4.52,10.1-10.1v-8.65c0-5.57-4.52-10.09-10.1-10.1M86.96,39.32h0c0,3.98-3.23,7.21-7.21,7.21h-11.54c-.29,0-.57.09-.81.25l-7.91,5.38c-.41.27-.95.16-1.22-.25-.1-.15-.15-.32-.15-.49v-20.75c0-3.98,3.23-7.21,7.21-7.21h14.42c3.98,0,7.21,3.23,7.21,7.21v8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_943",
    "data-name": "Trazado 943",
    className: "cls-robot4",
    d: "M73.98,63.84h-1.44c0-3.02-1.18-5.92-3.3-8.07-.56-.57-1.47-.58-2.04-.02-.57.56-.58,1.47-.02,2.04h0c1.59,1.61,2.48,3.79,2.47,6.06v14.42c0,4.78-3.88,8.65-8.65,8.66h-23.08c-4.78,0-8.65-3.88-8.65-8.66v-14.42c0-4.78,3.88-8.65,8.65-8.65h11.54c.8,0,1.44-.64,1.44-1.44v-7.21c.02-.8-.62-1.45-1.41-1.47-.8-.02-1.45.62-1.47,1.41,0,.02,0,.04,0,.06v5.77h-10.1c-6.37,0-11.53,5.17-11.54,11.54h-1.44c-2.39,0-4.32,1.94-4.33,4.33v8.65c0,2.39,1.94,4.32,4.33,4.33h1.81c1.32,5.09,5.91,8.65,11.17,8.65h23.08c5.26,0,9.85-3.56,11.17-8.65h1.81c2.39,0,4.32-1.94,4.33-4.33v-8.65c0-2.39-1.94-4.33-4.33-4.33M26.38,78.26h-1.44c-.8,0-1.44-.64-1.44-1.44v-8.65c0-.8.65-1.44,1.44-1.44h1.44v11.54ZM75.42,76.82c0,.8-.65,1.44-1.44,1.44h-1.44v-11.54h1.44c.8,0,1.44.65,1.44,1.44v8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_944",
    "data-name": "Trazado 944",
    className: "cls-robot4",
    d: "M40.81,66.73c-3.19,0-5.77,2.58-5.77,5.77s2.58,5.77,5.77,5.77,5.77-2.58,5.77-5.77c0-3.19-2.58-5.77-5.77-5.77M40.81,75.38c-1.59,0-2.88-1.29-2.88-2.89,0-1.59,1.29-2.88,2.89-2.88,1.59,0,2.88,1.29,2.88,2.89h0c0,1.59-1.29,2.88-2.89,2.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_945",
    "data-name": "Trazado 945",
    className: "cls-robot4",
    d: "M58.11,66.73c-3.19,0-5.77,2.58-5.77,5.77,0,3.19,2.58,5.77,5.77,5.77s5.77-2.58,5.77-5.77h0c0-3.19-2.58-5.77-5.77-5.77M58.11,75.38c-1.59,0-2.89-1.29-2.89-2.88,0-1.59,1.29-2.89,2.88-2.89,1.59,0,2.89,1.29,2.89,2.88h0c0,1.59-1.29,2.88-2.88,2.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_946",
    "data-name": "Trazado 946",
    className: "cls-robot4",
    d: "M66.16,32.65c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28c1.26,0,2.28-1.02,2.28-2.28,0-1.26-1.02-2.28-2.28-2.28M66.16,36.59c-.92,0-1.66-.74-1.66-1.66s.74-1.66,1.66-1.66c.92,0,1.66.74,1.66,1.66h0c0,.92-.74,1.66-1.66,1.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_947",
    "data-name": "Trazado 947",
    className: "cls-robot4",
    d: "M73.18,32.65c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28c1.26,0,2.28-1.02,2.28-2.28,0-1.26-1.02-2.28-2.28-2.28M73.18,36.59c-.92,0-1.66-.74-1.66-1.66s.74-1.66,1.66-1.66c.92,0,1.66.74,1.66,1.66h0c0,.92-.74,1.66-1.66,1.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_948",
    "data-name": "Trazado 948",
    className: "cls-robot4",
    d: "M80.2,32.65c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28c1.26,0,2.28-1.02,2.28-2.28,0-1.26-1.02-2.28-2.28-2.28M80.2,36.59c-.92,0-1.66-.74-1.66-1.66s.74-1.66,1.66-1.66c.92,0,1.66.74,1.66,1.66h0c0,.92-.74,1.66-1.66,1.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_949",
    "data-name": "Trazado 949",
    className: "cls-robot4",
    d: "M55.23,3.79C26.84,3.79,3.83,26.8,3.83,55.19s23.01,51.4,51.4,51.4,51.4-23.01,51.4-51.4h0c0-28.39-23.01-51.4-51.4-51.4,0,0,0,0,0,0M55.23,103.08c-26.45,0-47.89-21.44-47.89-47.89S28.78,7.29,55.23,7.29s47.89,21.44,47.89,47.89h0c0,26.45-21.44,47.89-47.89,47.89"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.6f63eb84eef762c6eab640e427b57a30.svg";
export { ForwardRef as ReactComponent };